import "./contact-us-page.styles.css";

import ContactUsImg from "../../assets/images/about-us.jpg";
import IntroBanner from "../../components/intro-banner/intro-banner/intro-banner.component";
import ContactUsForm from "../../components/contact-us-form/contact-us-form.component";
import ContactUsQuestionBox from "../../components/contact-us-question-box/contact-us-question-box.componen";

const ContactUsPage = () => {
  const contactUsBannerData = [
    {
      img: ContactUsImg,
      title: "ارتباط با ما",
    },
  ];

  const contactData = [
    {
      email: "Youngstoring@gmail.com",
      address: "تهران-میدان قدس-خیابان چمن-کوچه کیهان",
      number: "۰۹۱۲۹۵۱۹۹۳۰",
      instagram: "youngstoring",
    },
  ];

  return (
    <div className="contact-us-page">
      <IntroBanner
        cat={contactUsBannerData[0]}
        TitleclassName="contact-us-title"
      />

      <div className="container">
        <div className="contact-us-page-content-wrapper">
          <ContactUsForm />
          <ContactUsQuestionBox cat={contactData[0]} />
        </div>
      </div>
    </div>
  );
};

export default ContactUsPage;
